module.exports = __webpack_public_path__ + "img/hospitality-section-1-image.9c358ff7.png";